module.exports = __webpack_public_path__ + "img/buiten slapen.88613a42.jpg";